import { CircularProgress, IconButton } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import { useStyles } from './style';
import LinkIcon from '@material-ui/icons/Link';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
// import InstagramIcon from "@material-ui/icons/Instagram";
// import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import SucessIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import { useState } from 'react';
import { copyToClipboard, shareMail, whatsAppShare } from 'utils/share';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

interface Props {
    open: boolean;
    onClose: () => void;
    onMoreSelect: () => Promise<void>;
    text: string;
    subject: string;
    link: string;
    moreLoading?: boolean;
}

export default function BottomShareModal(props: Props) {
    const { open, onClose, text, subject, onMoreSelect, link, moreLoading } = props;

    const classes = useStyles();
    const [showElement, setShowElement] = useState(false);

    const handleClickCopyToClipboard = () => {
        return new Promise((resolve) => {
            copyToClipboard(link);
            setShowElement(true);
            setTimeout(() => {
                setShowElement(false);
                resolve('done');
            }, 1500);
        });
    };

    const sendWhatsApp = () => {
        whatsAppShare(text);
        onClose();
    };

    const sendEmail = () => {
        shareMail(text, subject);
        onClose();
    };

    const onMoreSelected = async () => {
        try {
            // setMoreLoading(true);
            await handleClickCopyToClipboard();
            await onMoreSelect();
        } catch (error) {
            console.error(error);
        } finally {
            // setMoreLoading(false);
        }
    };

    return (
        <Drawer
            open={open}
            onClose={onClose}
            anchor="bottom"
            PaperProps={{
                className: classes.drawer,
            }}
        >
            <div>
                <div className={`d-flex`}>
                    <h6 className={`text-center mx-auto ${classes.shareTitle}`}>Share</h6>
                    <CloseIcon className={classes.closeIcon} onClick={onClose} />
                </div>
                <div className={classes.shareContent}>
                    <div className="d-flex flex-column">
                        <IconButton
                            className={classes.linkButton}
                            onClick={() => {
                                handleClickCopyToClipboard();
                            }}
                        >
                            <LinkIcon />
                        </IconButton>
                        <span className={`text-center ${classes.iconLabel}`}>Link</span>
                    </div>

                    {/* <div className="d-flex flex-column">
                        <IconButton className={classes.instagramButton}>
                            <InstagramIcon />
                        </IconButton>
                        <span className={`text-center ${classes.iconLabel}`}>Instagram</span>
                    </div> */}
                    <div className="d-flex flex-column">
                        <IconButton className={classes.mailBtn} onClick={sendEmail}>
                            <MailOutlineIcon />
                        </IconButton>
                        <span className={`text-center ${classes.iconLabel}`}>Еmail</span>
                    </div>
                    <div className="d-flex flex-column">
                        <IconButton className={classes.whtsAppBtn} onClick={sendWhatsApp}>
                            <WhatsAppIcon />
                        </IconButton>
                        <span className={`text-center ${classes.iconLabel}`}>WhatsApp</span>
                    </div>
                    {(!!navigator.share || process.env.NODE_ENV === 'development') && (
                        <div className="d-flex flex-column">
                            <IconButton
                                className={classes.moreBtn}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (!moreLoading) {
                                        onMoreSelected();
                                    }
                                }}
                            >
                                {!moreLoading ? <MoreHorizIcon /> : <CircularProgress size={24} />}
                            </IconButton>
                            <span className={`text-center ${classes.iconLabel}`}>More</span>
                        </div>
                    )}
                </div>

                <div className={showElement ? classes.copyMsg : classes.noneCopyMsg}>
                    <SucessIcon className={classes.successIcon} />
                    Link copied to clipboard
                </div>
            </div>
        </Drawer>
    );
}
